/**
 * The row and column ids resolved from a context menu event target.
 */
export interface IScaffoldContextMenuTarget {
  /** Scaffold column id of the right-clicked cell. */
  colId: string;
  /** Scaffold row id of the right-clicked cell. */
  rowId: string;
}

/**
 * Extracts the scaffold row and column ids from a context menu event target by walking up
 * the DOM to the nearest element annotated with both `data-scaffold-col-id` and
 * `data-scaffold-row-id`.  Returns `undefined` when the event did not originate from inside
 * a scaffold cell.
 *
 * @param target - Event target from the context menu capture event
 * @returns The scaffold row and column ids when available; otherwise undefined
 */
export const getScaffoldContextMenuTarget = (
  target: EventTarget | null,
): IScaffoldContextMenuTarget | undefined => {
  if (target instanceof Element) {
    const scaffoldCell = target.closest("[data-scaffold-col-id]");
    const colId = scaffoldCell?.getAttribute("data-scaffold-col-id");
    const rowId = scaffoldCell?.getAttribute("data-scaffold-row-id");
    if (colId && rowId) {
      return { colId, rowId };
    }
  }
  return undefined;
};
